import React, { useContext,useState,useRef,useEffect, Dispatch, SetStateAction } from "react";
import './pageCreation.css'
import { AppContext } from "../../../context/AppContext";
import InputForm from "../../../components/inputForm/InputForm";
import DOMPurify from "dompurify";
import { useNavigate } from "react-router-dom";
import MaskBackground from "../../../components/maskBackground/maskBackground";

const LoadScriptOnce: React.FC<{children: React.ReactNode }> = ({children }) => {
  const { scriptLoad, setScriptLoad } = useContext(AppContext);

  useEffect(() => {
    const loadGoogleMapsScript = () => {
      if (scriptLoad) return <>{children}</>;

      const existingScript = document.querySelector(`script[src*="maps.googleapis.com/maps/api/js"]`);
      if (existingScript) {
        return;
      }

      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_API_KEY_MAP}&libraries=places`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        setScriptLoad(true);

      };

      script.onerror = () => {
        console.error("Erreur lors du chargement du script Google Maps.");
        setScriptLoad(false);
      };

      document.head.appendChild(script);
    };

    loadGoogleMapsScript();
    return setScriptLoad(false)
  }, [scriptLoad, setScriptLoad]);

  return <>{children}</>;
};


interface PageCreationProps {
    validPage:(id:number) => void,
    token:string,
    nameResto: string;
    setNameResto: Dispatch<SetStateAction<string>>,
    newsletterStart: boolean;
    postalCode: number;
    setPostalCode:Dispatch<SetStateAction<number>>,
    address: string;
    setAddress: Dispatch<SetStateAction<string>>,
    city: string;
    setCity: Dispatch<SetStateAction<string>>,
    phone: string;
    setPhone: Dispatch<SetStateAction<string>>,
    latStart: number;
    lngStart: number;
}

const PageCreation:React.FC<PageCreationProps> = ({validPage,token,nameResto,setNameResto,newsletterStart,postalCode,setPostalCode,latStart,lngStart,address,setAddress,city,setCity,phone,setPhone}) => {
    const {setIdProfil,setIsLogin,setIsAuthenticated,setName,setIdRestaurant,setNewsLetter,scriptLoad} = useContext(AppContext)
    

    const [validName, setValidName] = useState(true)

    const [confirmAddress, setConfirmAddress] = useState(true)
    const [coordonate,setCoordonate] = useState<[Number,Number] | null>((latStart !== 0 && lngStart !== 0 )?  [latStart,lngStart] : null)

    const [validAddress, setValidAddress] = useState(true)
    const [addressComplete,setAddressComplete] = useState(false)
    const [validPhone, setValidPhone] = useState(true);
    const [errorCondtion,setErrorCondtion] = useState(false)
    const [validConditions,setValidCondtions] = useState(false)
    const [acceptNews,setAcceptNews] = useState(newsletterStart)
    const refAddress = useRef<HTMLInputElement>(null)
    const [showManualAddress,setShowManualAddress] = useState(false)
    const [visibleAddress,setVisibleAddress] = useState(address && city ? (`${address} - ${city}`) : (address ? address : (city ? city : '')))

    const navigate= useNavigate()
    useEffect(() => {
        setTimeout(() => { window.scrollTo(0,0)},10)
    },[])
    const handleNext = async () => {
        if(nameResto.length < 2 || nameResto.length > 50) setValidName(false)
        else setValidName(true)
        if(visibleAddress.length < 5 || visibleAddress.length > 120) setValidAddress(false)
        else setValidAddress(true)
        const formatPhone = phone.replace(/\s+/g, '');
        if(formatPhone.length !== 10) setValidPhone(false)
        else setValidPhone(true)
        if(validConditions) setErrorCondtion(false)
        else setErrorCondtion(true)
    
        if( (nameResto.length <= 50 && nameResto.length >= 2) && formatPhone.length === 10 && (visibleAddress.length <= 120 && visibleAddress.length >= 5) && validConditions )  {
            const cleanName = DOMPurify.sanitize(nameResto)
            let cleanAddress= DOMPurify.sanitize(address)
            let cleanVisible= DOMPurify.sanitize(visibleAddress)
            let cleanCity = DOMPurify.sanitize(city)
            let result:{ lat: any; lng: any; formattedAddress: any; city: string;postal_code:number } | null |undefined = undefined
            if(coordonate && addressComplete &&  cleanCity && cleanAddress && postalCode) result = {lat:coordonate[0], lng :coordonate[1], formattedAddress:cleanAddress, city:cleanCity,postal_code:postalCode}
            const cleanPhone = DOMPurify.sanitize(formatPhone)
            if (result && addressComplete) {
                setConfirmAddress(true)
                cleanAddress = result.formattedAddress.split(',')[0]; 
                cleanCity  = result.city || cleanCity;
                validPage(1); 
                try {
                    const response = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/registerTempSecond`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            name: cleanName,
                            address: cleanAddress,
                            city: cleanCity,
                            phone: cleanPhone,
                            token: token,
                            lat: result.lat,
                            lng: result.lng,
                            newsletter:acceptNews,
                            postalCode: result.postal_code
                        })
                    });
            
                    if (!response.ok) {
                        return; 
                    }
                    const data = await response.json();
                    if (data.success) {
                        localStorage.setItem('token', data.token);
                        setIsLogin(2)
                        setIdProfil(data.login.idr)
                        setName(data.login.name)
                        setIdRestaurant(data.login.idrestaurant)
                        setIsAuthenticated(true)
                        navigate('/')
                        setNewsLetter(acceptNews)
                    } 
                } catch (error) {
                    
                    console.error("Erreur lors de la vérification du code:", error);
                }
            } else {
                await fetchCoordinates(cleanVisible,cleanCity)         
            } 
        } 
    }
    const formatPhoneNumber = (value: string) => {
        const cleaned = value.replace(/\D+/g, '');
        return cleaned.replace(/(\d{2})(?=\d)/g, '$1 ');
        };
    const handleChangePhone = (event:React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value
        if (/^[0-9 ]*$/.test(value)) {
            if (value.length < 15) {
                const formattedValue = formatPhoneNumber(value);
                setPhone(formattedValue);
            }
        }
        };
    const handleBlurPhone = (event:React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (/^[0-9 ]*$/.test(value)) {
            if (value.length >= 15) {
                setPhone('');
            }
        }
    }


    async function fetchCoordinates (address: string, city: string)  {
        try {
            const response = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/getAddress`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({ address: address, city: city}) })
            const data = await response.json()
            if (data.status === 'OK' && data.results.length > 0 &&   data.results[0].address_components) {
                const location = data.results[0].geometry.location;

                const components: google.maps.GeocoderAddressComponent[] = data.results[0].address_components;
                const getComponent = (type: string) => components.find((comp) => comp.types.includes(type))?.long_name || '';
                const streetNumber = getComponent('street_number') || getComponent('colloquial_area') || getComponent('sublocality') || getComponent('neighborhood');
                const route = getComponent('route');
                const postalCode = getComponent('postal_code');
                const city = getComponent('locality') || getComponent('postal_town') || getComponent('administrative_area_level_2');
                const address= `${streetNumber} ${route}`.trim(); 
                if(address && city && postalCode && location.lat && location.lng)   {
                    setPostalCode(parseInt(postalCode))
                    setAddress(address)
                    setCity(city)
                    setCoordonate([location.lat,location.lng])
                    setVisibleAddress(address + ' - ' + city)   
                    setAddressComplete(true)
                    setTimeout(() => {setShowManualAddress(true)},400);
                } else {
                    setConfirmAddress(false)
                    if (refAddress.current) {
                        refAddress.current.scrollIntoView({ behavior: "smooth", block: "center" });
                    }
                } 
                
            } else {
                setConfirmAddress(false)
                if (refAddress.current) {
                    refAddress.current.scrollIntoView({ behavior: "smooth", block: "center" });
                }
            }
        } catch (error) {
            console.error('Error fetching coordinates:', error);
            setConfirmAddress(false)
            if (refAddress.current) {
                refAddress.current.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }
    };

    const inputAddressRef = useRef<HTMLInputElement>(null);
 
    const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null);
    useEffect(() => {
        if (visibleAddress.length >= 5 && inputAddressRef.current && !autocompleteRef.current) {
            if (!window.google || !window.google.maps) {
                console.error("Google Maps API non chargée !");
                return;
            }
          autocompleteRef.current = new window.google.maps.places.Autocomplete(inputAddressRef.current, {
            types: ['address'],
            componentRestrictions: { country: 'fr' },
          });
    
          autocompleteRef.current.addListener('place_changed', () => {
            const place = autocompleteRef.current?.getPlace();
            if (place && place.address_components) {
                const components = place.address_components;
                const getComponent = (type: string) => components.find((comp) => comp.types.includes(type))?.long_name || '';
                
                
                const streetNumber = getComponent('street_number');
                const route = getComponent('route');
                const postalCode = getComponent('postal_code');
                const city = getComponent('locality') || getComponent('postal_town') || getComponent('administrative_area_level_2');
                const address = `${streetNumber} ${route}`.trim();

                const location = place.geometry?.location;
                if (location) {
                    const lat = location.lat();
                    const lng = location.lng();
                    setCoordonate([lat, lng]);
                }
                setVisibleAddress(address + ' - ' + city)
                setAddress(address);
                setCity(city || ''); 
                setAddressComplete(true); 
                setPostalCode(parseInt(postalCode))
            }
          });
        }
    
      }, [visibleAddress]);

    return (
        <div className='pageCreation '>
            <LoadScriptOnce >
            <div className="main">
                <InputForm value={nameResto} setValue={setNameResto} PrimaryText="Nom du restaurant" SecondaryText="Nom incorrect"  idInput="inputNameResto" placeHolder="Nom du restaurant" maxLength={50} valid={validName} setValid={setValidName}/>
                
                <div className="address" style={{marginTop:'10px'}}>
                    { !confirmAddress && <p ref={refAddress} className="smallText" style={{color:'red'}}>L'adresse est introuvable. Veuillez vérifier l'orthographe. </p>}
                    <p className="smallTextBold" style={!validAddress ? {color:'red'}:{}}>{validAddress ? 'Adresse du restaurant' : 'Adresse incorrecte'}</p>
                    <input
                        ref={inputAddressRef}
                        type="text"
                        className="smallText"
                        placeholder="Adresse..."
                        autoComplete="new-password"
                        name="q_addr"
                        style={!validAddress ? {border:'1px solid red'}:{}}
                        value={visibleAddress}
                        maxLength={120}
                        onChange={(e) => {setVisibleAddress(e.target.value);setAddressComplete(false);setValidAddress(true)}}
                        onFocus={(e) => e.currentTarget.setAttribute('autocomplete', 'new-password')}
                    />      
                </div>   


                <div className="inputPhone">                           
                    <p className="smallTextBold"  style={!validPhone ? {color:'red'} : {}}>{ !validPhone ? `Le numéro de téléphone n'est pas valide` : 'Téléphone du restaurant' }</p>
                    <input style={! validPhone ? {border:'1px solid red'} : {}} type="text" className="smallText" value={phone} onChange={handleChangePhone} onBlur={handleBlurPhone} inputMode="numeric" pattern="\d*"/>
                </div>
                <div  className={`condition XsmallText ${errorCondtion && !validConditions  && 'error'}`}>
                    <div className={`pointer lowOpacityHover ${validConditions && 'full1'}`} onClick={() => setValidCondtions(!validConditions)}></div>
                    <i>J'ai lu et j'accepte les <a href='/ConditionsGeneralesVenteResto' target="_blank">Conditions Générales de Vente</a> et les <a href='/ConditionsGeneralesUtilisation' target="_blank">Conditions Générales d'Utilisation</a> de QuelResto.</i>
                </div>
                <div className="condition XsmallText">
                    <div className={`pointer lowOpacityHover ${acceptNews && 'full2'}`} onClick={() => setAcceptNews(!acceptNews)}></div>
                    <i>J'accepte de recevoir des offres commerciales et promotionnelles de QuelResto.</i>
                </div>
            </div>


            <div className="button " onClick={handleNext} >
                <p className="midTextBold longGoldButton ">S'inscrire</p>
            </div>
            {
                showManualAddress && <><div className="containerConfirmAddressCreation primaryBack smallText">
                        <p className="midTitle" style={{marginTop:0,marginBottom:'20px'}}>Confirmation de votre adresse</p>
                        <p className="widthElem">Vous avez rentré votre adresse manuellement, confirmez-vous que l'adresse suivante est bien la vôtre ?</p>
                        <div className="addressConfirm widthElem">
                            <p>Adresse : </p>
                            <div className="primaryBack">{address}, {postalCode}, {city}</div>
                            
                        </div>
                        <div className="button widthElem">
                            <p className="midWhiteButton smallText" onClick={() => {setShowManualAddress(false);setVisibleAddress(address);setAddressComplete(false);setTimeout(() => {inputAddressRef.current?.focus()}, 0)}}>Modifier</p>
                            <p className="midGoldButton smallText" onClick={() => {setShowManualAddress(false);handleNext()}}>Confirmer l'adresse</p>
                        </div>
                    </div>
                    <MaskBackground zIndex={25}/>
                    </>
            }
            </LoadScriptOnce>
        </div>
    )
}

export default PageCreation